module.exports = __webpack_public_path__ + "static/cars2-56a7c4609b46dcabd60313cb873e5ac5.png";